import type { FunctionalComponent, HTMLAttributes } from 'vue'

export const HandicapBuyIcon: FunctionalComponent<
  HTMLAttributes & {
    isActive?: boolean
  }
> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g opacity={props.isActive ? 1 : 0.5}>
        <path d="M2.66797 2.66406H7.33463V13.3308H2.66797V2.66406Z" fill="var(--colors-up)" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.66797 2.66406H13.3346V5.33073H8.66797V2.66406ZM8.66797 6.66406H13.3346V9.33073H8.66797V6.66406ZM13.3346 10.6641H8.66797V13.3308H13.3346V10.6641Z"
          fill="#75777A"
        />
      </g>
    </svg>
  )
}
